/**
 * Runtime backend URL detection.
 * 
 * Problem: REACT_APP_BACKEND_URL is baked in at build time (webpack DefinePlugin).
 * When deployed to production (ophilia.app), the build may contain a stale
 * Emergent preview URL that no longer exists.
 * 
 * Solution: Detect production hostname at runtime and use same-origin (empty string)
 * so API calls go to /api/... on the same domain via the production proxy.
 */
function getBackendUrl() {
  const hostname = window.location.hostname;
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  const isPreview =
    hostname.endsWith('emergent.host') ||
    hostname.endsWith('preview.emergentagent.com');
  const isCustomDomain = !isLocal && !isPreview;

  if (isCustomDomain) {
    return '';
  }

  return process.env.REACT_APP_BACKEND_URL || '';
}

export const BACKEND_URL = getBackendUrl();
